import  useBanner from './useBanner';
export default useBanner
